// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1FLbB","body-wrapper":"body-wrapper__2KUM_","body":"body__3f9ql"};